import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { useSequence } from "../components/SequenceProvider";
import { AuthContext } from "../contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isSequenceStarted, isSequenceCompleted } = useSequence();
  const { user } = useContext(AuthContext);

  if (!isSequenceStarted || isSequenceCompleted) {
    return <Navigate to={`/${user?.user_id}/manager/assessments`} />;
  }

  return children;
};

export default ProtectedRoute;
